import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	pirDefaultTemplateName: {
		id: 'servicedesk-incident-management-settings.post-incident-reviews.templates.pir-default-template-name',
		defaultMessage: 'Default post-incident review template',
		description: 'Default template "Post Incident Reviews"',
	},
	pirTemplatesSubSectionHead: {
		id: 'servicedesk-incident-management-settings.post-incident-reviews.templates.pir-templates-sub-section-head',
		defaultMessage: 'TEMPLATES',
		description: 'Title text, Post Incident Reviews templates settings subsection',
	},
	pirDefaultTemplatesLozengeText: {
		id: 'servicedesk-incident-management-settings.post-incident-reviews.templates.pir-default-templates-lozenge-text',
		defaultMessage: 'DEFAULT',
		description:
			'Lozenge text to show a particular Post Incident Reviews templates will be used by default',
	},
});
